/**
 * Canonical API field names for store credit notes (see plan).
 * Do not read alternate aliases in UI code.
 */

export const CREDIT_NOTE_STATUS = {
  OPEN: "open",
  CLOSED: "closed",
};

export const CREDIT_NOTE_TYPE = {
  DEALER: "dealer",
  DIRECT_BUYER: "direct_buyer",
};

export const PARTY_SCOPE = {
  DEALER: "dealer",
  DIRECT_BUYER: "direct_buyer",
};

/**
 * @typedef {Object} CreditNote
 * @property {number} id
 * @property {string} identifier
 * @property {'open'|'closed'} status
 * @property {number} value
 * @property {number} balance
 * @property {'dealer'|'direct_buyer'} type
 * @property {number|null} store_dealer_id
 * @property {number|null} store_buyer_id
 * @property {string|null} last_adjusted_at
 * @property {string|null} [credit_remarks]
 * @property {CreditNoteUsageProject[]} [usage_projects]
 */

/**
 * @typedef {Object} CreditNoteUsageProject
 * @property {number} project_id
 * @property {string} project_name
 * @property {number} project_value
 * @property {number} project_credit_total
 * @property {number} pending_payment
 * @property {string} [customer_name]
 * @property {number} credit_applied
 * @property {string} [adjusted_at]
 */

/**
 * @typedef {Object} CreditAdjustment
 * @property {number} id
 * @property {number} credit_note_id
 * @property {number} project_id
 * @property {string} project_name
 * @property {number} project_value
 * @property {number} [project_credit_total]
 * @property {number} [pending_payment]
 * @property {string} [customer_name]
 * @property {number} value
 * @property {string} adjusted_at
 */

/**
 * @typedef {Object} AvailableCreditNote
 * @property {number} id
 * @property {string} identifier
 * @property {number} balance
 * @property {'open'|'closed'} status
 */

/**
 * @typedef {Object} DealerDiscountRow
 * @property {number} per
 * @property {number} value
 * @property {number} effective_value
 */

export function isCreditUsed({ credit_adjustments_total }) {
  const total = Number(credit_adjustments_total);
  return Number.isFinite(total) && total > 0;
}

export function creditUsedTotal({ credit_adjustments_total }) {
  const total = Number(credit_adjustments_total);
  return Number.isFinite(total) && total > 0 ? total : 0;
}
